import { breakpoints, fontFamilies } from "@brightagency/headstart-common";
import styled from "styled-components";
import { colors } from "../../../../utils/colors";

export const Outer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 24px;

    ${breakpoints.large} {
        margin-bottom: 16px;
        flex-direction: row;
        justify-content: space-between;
        text-align: left;
    }
`;

export const ListingCount = styled.div`
    font-size: 24px;
    color: ${colors.brandDark};
    margin-bottom: 24px;
    font-family: ${fontFamilies.heading} !important;

    ${breakpoints.large} {
        font-size: 32px;
        margin-bottom: 0;
    }
`;

export const Actions = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    flex-shrink: 0;
    gap: 0.75rem;

    ${breakpoints.custom(640)} {
        gap: 24px;
    }
    ${breakpoints.large} {
        width: auto;
    }
`;

export const Buttons = styled.div`
    display: flex;
    gap: 8px;
`;

export const SortButtonWrapper = styled.div`
    margin-right: 0;
    width: 100%;
    text-align: left;

    ${breakpoints.large} {
        margin-right: 24px;
    }

    .carousel-wrapper{
        background-color: transparent;
        padding: 0;

        .carousel-track{
            padding: 0 !important;
        }
        .carousel-container{
            padding: 0 !important;
            > div {
                justify-content: center;
            }
        }
        .carousel-item{
            ${breakpoints.small} {
                width: auto !important;
            }
        }
        &#sortButtons {
            .carousel-container{
                > div{
                    justify-content: flex-start;
                }
            }
        }
    }
    
`;